import OneuserAddressBook from '../../pages/oneuser/addressbook';
import OneuserCalendar from '../../pages/oneuser/calendar/calendar';
import { AvailableCommunities } from '../../pages/oneuser/community/availablecommunities/containers/availablecommunities';
import MyCommunities from '../../pages/oneuser/community/mycommunities/containers/mycommunities';
import MyCommunity from '../../pages/oneuser/community/mycommunities/containers/mycommunity';
import { AvailableEvents } from '../../pages/oneuser/events/availableevents/containers/availableevents';
import Myevent from '../../pages/oneuser/events/myevents/containers/myevent';
import MyEvents from '../../pages/oneuser/events/myevents/containers/myevents';
import Forums from '../../pages/oneuser/forums/containers/forums';
import OneuserHelpCenter from '../../pages/oneuser/helpcenter';
import Inbox from '../../pages/oneuser/inbox/containers/inbox';
import Inboxes from '../../pages/oneuser/inbox/containers/inboxes';
import OneuserProfile from '../../pages/oneuser/profile';
import { AvailablePrograms } from '../../pages/oneuser/programs/availableprograms/containers/availableprograms';
import Myprogram from '../../pages/oneuser/programs/myprograms/containers/myprogram';
import MyPrograms from '../../pages/oneuser/programs/myprograms/containers/myprograms';
import OneuserWorkingInProgress from '../../pages/oneuser/wip';
import { RoleGuard } from '../guards';








export const OneuserRoutes = () => {

	return ([
		
		// Start - Profile
		{ path: 'wip', element: <RoleGuard roles={["Trainer"]}><OneuserWorkingInProgress /></RoleGuard>},
		{ path: 'profile', element: <RoleGuard roles={["Oneuser"]}><OneuserProfile /></RoleGuard>},
		{ path: 'helpcenter', element: <RoleGuard roles={["Oneuser"]}><OneuserHelpCenter /></RoleGuard>},
		{ path: 'address', element: <RoleGuard roles={["Oneuser"]}><OneuserAddressBook /></RoleGuard>},
		{ path: 'wip', element: <RoleGuard roles={["Oneuser"]}><OneuserWorkingInProgress /></RoleGuard>},
		{ path: 'community/mycommunities', element: <RoleGuard roles={["Oneuser"]}><MyCommunities /></RoleGuard>},
		{ path: 'community/mycommunities/:id', element: <RoleGuard roles={["Oneuser"]}><MyCommunity /></RoleGuard>},
		{ path: 'forums', element: <RoleGuard roles={["Oneuser"]}><Forums /></RoleGuard>},
		{ path: 'events/availableevents', element: <RoleGuard roles={["Oneuser"]}><AvailableEvents /></RoleGuard>},
		{ path: 'events/myevents', element: <RoleGuard roles={["Oneuser"]}><MyEvents /></RoleGuard>},
		{ path: 'events/myevents/:id', element: <RoleGuard roles={["Oneuser"]}><Myevent /></RoleGuard>},
		{ path: 'programs/myprograms', element: <RoleGuard roles={["Oneuser"]}><MyPrograms /></RoleGuard>},
		{ path: 'programs/myprograms/:id', element: <RoleGuard roles={["Oneuser"]}><Myprogram /></RoleGuard>},
		{ path: 'programs/availableprograms', element: <RoleGuard roles={["Oneuser"]}><AvailablePrograms /></RoleGuard>},
		{ path: 'community/availablecommunities', element: <RoleGuard roles={["Oneuser"]}><AvailableCommunities /></RoleGuard>},
		{ path: 'inbox', element: <RoleGuard roles={["Oneuser"]}><Inboxes /></RoleGuard>},
		{ path: 'inbox/:id', element: <RoleGuard roles={["Oneuser"]}><Inbox /></RoleGuard>},
		{ path: 'calendar', element: <RoleGuard roles={["Oneuser"]}><OneuserCalendar /></RoleGuard>},

	])	
}; 
